export default __webpack_public_path__ + "static/media/pdv_m_bg.8c340044.png";